import { Coordinate } from "./common";
import { Photo } from "./photo";
import { BusinessVertical } from "./vertical";

export enum CompanyStatus {
  ACTIVE = "active",
  PENDING = "pending",
  INACTIVE = "in-active",
}

export interface Company {
  id: number;
  business_vertical_id: number;
  name: string;
  city: string;
  state: string;
  zip: string;
  country_id: number;
  headquarters_address_1: string;
  headquarters_address_2: string;
  billing_country_id: number;
  billing_address_1: string;
  billing_address_2: string;
  billing_city: string;
  billing_state: string;
  billing_zip: string;
  billing_email: string;
  balance_decrypt: number;
  coordinate: Coordinate;
  percentage_uplift: string;
  fixed_price_fee: number;
  color_schema: string;
  phone_number: string;
  fax: string;
  business_vertical: BusinessVertical;
  website: string;
  linked_in: string;
  facebook: string;
  instagram: string;
  primary_contact_name: string;
  primary_contact_title: string;
  primary_contact_phone_number: string;
  primary_contact_email: string;
  total_rating: number;
  status: string;
  logo: Array<Photo>;
  //total_job: number;
  //total_job_success_rate: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}
